import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
// import { Generic, JSONLD } from 'react-structured-data';
import axios from 'axios';
import Hashids from 'hashids/cjs';
import Skeleton from '@material-ui/core/Skeleton';
import { connect } from 'react-redux';
import { Avatar } from '@material-ui/core';
import ContentEditable from 'react-contenteditable';
import Icon from '../../components/Icon';
import RelatedCard from '../../components/RelatedCard';
import ActionIconGroup from '../../components/ActionIconGroup';
import { saveItem, unsaveItem } from '../SavedItems/helper';
// import withAmp from 'react-storefront-extensions/amp/withAmp'
import './style.scss';
import PageWrap from '../../components/page-wrap';
import ShareIntent from '../../utils/shareUtils';
import ShareItem from '../../models/ShareItem';
import Carousel from '../../components/carousel';
import CommentList from '../Comments/components/commentlist';
import { Button } from 'reactstrap';
import { ArticleStore } from '../../stores';
import PageMeta from '../../components/PageMeta';
import { Resize } from '../../utils/imageUtils';

const hashids = new Hashids('', 12);
const env = process.env.NODE_ENV || 'development';
const config = require('../../../config/config.json')[env];

let lastPostId = -1;

const updateLinks = (content) =>
  // TODO Consider routing for internal links as long as it doesn't affect SEO - if it does, do conditional rendering
  //  so that bots get anchor links but users get JS routing for a better app experience
  //  Alternatively, look into a link interceptor that automatically handles internal links as routes
  content.replace(/boxpressd\.app/g, 'app.boxpressd.com');
export const mainMobileLeaderboard = () => (
  <iframe
    src="https://media.aso1.net/js/ifr.html#id=107876"
    width="320"
    height="50"
    align="center"
    frameBorder="0"
    marginHeight="0"
    marginWidth="0"
    scrolling="no"
    style={{ width: 320, height: 50, overflow: 'hidden', border: 'none' }}
  />
);
const mainLeaderboard = () => (
  <iframe
    src="https://media.aso1.net/js/ifr.html#id=101321"
    width="728"
    height="90"
    align="center"
    frameBorder="0"
    marginHeight="0"
    marginWidth="0"
    scrolling="no"
    style={{ width: 728, height: 90, overflow: 'hidden', border: 'none' }}
  />
);
const secondaryLeaderboard = () => (
  <iframe
    src="https://media.aso1.net/js/ifr.html#id=106558"
    width="728"
    height="90"
    align="center"
    frameBorder="0"
    hspace="0"
    vspace="0"
    marginHeight="0"
    marginWidth="0"
    scrolling="no"
    style={{ width: 728, height: 90, overflow: 'hidden', border: 'none' }}
  >
  </iframe>
);
export const mainTower = () => (
  <iframe
    src="https://media.aso1.net/js/ifr.html#id=107878"
    width="300"
    height="600"
    align="center"
    frameBorder="0"
    marginHeight="0"
    marginWidth="0"
    scrolling="no"
    style={{ width: 300, height: 600, overflow: 'hidden', border: 'none', marginBottom: 20 }}
  />
);
export const mainMediumRectangle = () => (
  <iframe
    src="https://media.aso1.net/js/ifr.html#id=107876"
    width="300"
    height="250"
    align="center"
    frameBorder="0"
    hspace="0"
    vspace="0"
    marginHeight="0"
    marginWidth="0"
    scrolling="no"
    style={{ width: 300, height: 250, overflow: 'hidden', border: 'none', marginBottom: 20 }}
  />
);
export const secondaryMediumRectangle = () => (
  <iframe
    src="https://media.aso1.net/js/ifr.html#id=107877"
    width="300"
    height="250"
    align="center"
    frameBorder="0"
    marginHeight="0"
    marginWidth="0"
    scrolling="no"
    style={{ width: 300, height: 250, overflow: 'hidden', border: 'none', marginBottom: 20 }}
  />
);
export const tertiaryMediumRectangle = () => (
  <iframe
    src="https://media.aso1.net/js/ifr.html#id=106557"
    width="300"
    height="250"
    align="center"
    frameBorder="0"
    marginHeight="0"
    marginWidth="0"
    scrolling="no"
    style={{
      width: 300,
      height: 250,
      overflow: 'hidden',
      border: 'none',
      marginBottom: 20,
    }}
  />
);

// TODO Possible AMP conversion https://pwa.moovweb.com/v6.5.0/guides/amp for these 'articles'
// https://stackoverflow.com/questions/43367687/google-amp-with-react
// @withAmp
class WpPostDetail extends PureComponent {
  loadedCigarDetails = null; // Ensures it only runs once per load

  loadedCigarProducts = null;

  loadedVenueDetails = null;

  constructor(props) {
    super(props);
    this.state = {
      cigar: null,
      comments: [],
      commentText: null,
      showCigarDetails: false,
      showCigarProducts: false,
      showVenueDetails: false,
      itemSaved: false,
    };
  }

  componentDidMount() {
    const { loadRelatedItem, item, related } = this.props;
    if (item && related.size === 0) {
      loadRelatedItem(item);
    }

    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { loadItem, loadRelatedItem } = this.props;
    const { item, related, match: { params } } = nextProps;
    const postId = hashids.decode(params.postId)[0];

    if (item) {
      if (window.analytics) {
        window.analytics.page('Cigar Review Article', null, {
          item_id: item.id,
          item_type: 'articles',
          name: item.title,
        });
      }
      lastPostId = postId;
      if (related.size === 0) {
        loadRelatedItem(item);
      }
    }
    if (lastPostId !== postId) {
      lastPostId = postId;
      loadItem(postId);
    }

    if (item) {
      if (lastPostId !== item.id) {
        this.loadedCigarDetails = null;
        this.loadedCigarProducts = null;
        this.loadedVenueDetails = null;
      }
      this.checkHasCigarDetails();
      this.checkHasCigarProducts();
      this.checkHasVenueDetails();
      this.checkComments();
    }

    const savedArticles = ArticleStore.getRawState().saved;
    savedArticles.forEach((itemId) => {
      if (parseInt(itemId) === parseInt(postId)) {
        this.setState({ itemSaved: true });
      }
    });
  }

  toggleSavedItem = (save) => {
    let { item, auth } = this.props;
    const { user } = auth;
    item = JSON.parse(JSON.stringify(item));
    console.log('Toggling saved item for state:');
    if (save) {
      console.log('save');
      saveItem(user, 'article', item);
    } else {
      console.log('unsave');
      unsaveItem(user, item);
    }
  };

  // scrollToComments = () => {
  //   document.getElementById('comment-container').scrollIntoView({
  //     behavior: 'smooth',
  //     block: 'start',
  //   });
  // };

  shareArticle = () => {
    const { item } = this.props;
    ShareIntent.share(new ShareItem({
      title: item.title && item.title.replace(/<[^>]*>?/gm, ''),
      text: item.intro && item.intro.replace(/<[^>]*>?/gm, ''),
      path: 'article',
      route: `/articles/${hashids.encode(item.id)}`,
      image: item.largeImage || item.image,
    }));
  }

  formatDate = (dateStr) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', options); // TODO How to get user's locale?
  };

  checkHasCigarDetails = () => {
    const { item } = this.props;
    console.log('Post details:');
    console.log(item);
    if (item && item.cigar_id) {
      // if (this.loadedCigarDetails === null) {
      console.log(`${config.embedEndPoint}/cigars/${item.cigar_id}/details`);
      axios.get(`${config.embedEndPoint}/cigars/${item.cigar_id}/details`)
        .then(() => {
          console.log('Got detail widget');
          // https://stackoverflow.com/questions/16504816/how-to-set-html-content-into-an-iframe
          // TODO ^^^ Might be able to load the html directly into the iframe instead of making another call
          this.loadedCigarDetails = true;
          this.setState({
            showCigarDetails: true,
          });
        }).catch((err) => {
          console.log(err);
          this.loadedCigarDetails = true;
          this.setState({
            showCigarDetails: false,
          });
        });
      // }
    } else {
      this.setState({
        showCigarDetails: false,
      });
    }
  };

  checkHasCigarProducts = () => {
    const { item } = this.props;
    if (item && item.cigar_id) {
      // if (this.loadedCigarProducts === null) {
      console.log(`${config.embedEndPoint}/products/cigars/${item.cigar_id}/buybutton`);
      axios.get(`${config.embedEndPoint}/products/cigars/${item.cigar_id}/buybutton`)
        .then(() => {
          console.log('Got product carousel widget');
          this.loadedCigarProducts = true;
          this.setState({
            showCigarProducts: true,
          });
        }).catch((err) => {
          console.log(err);
          this.loadedCigarProducts = true;
          this.setState({
            showCigarProducts: false,
          });
        });
      // }
    } else {
      this.setState({
        showCigarProducts: false,
      });
    }
  };

  checkHasVenueDetails = () => {
    const { item } = this.props;
    console.log('Post details:');
    console.log(item);
    console.log('Checking for venue card...');
    console.log(item && item.venue_id);
    if (item && item.venue_id) {
      // if (this.loadedVenueDetails === null) {
      console.log(`${config.embedEndPoint}/venues/${item.venue_id}/details`);
      axios.get(`${config.embedEndPoint}/venues/${item.venue_id}/details`)
        .then(() => {
          console.log('Got detail widget');
          // https://stackoverflow.com/questions/16504816/how-to-set-html-content-into-an-iframe
          // TODO ^^^ Might be able to load the html directly into the iframe instead of making another call
          this.loadedVenueDetails = true;
          this.setState({
            showVenueDetails: true,
          });
        }).catch((err) => {
          console.log(err);
          this.loadedVenueDetails = true;
          this.setState({
            showVenueDetails: false,
          });
        });
      // }
    } else {
      this.setState({
        showVenueDetails: false,
      });
    }
  };

  checkComments = () => {
    const { match: { params } } = this.props;
    const postId = hashids.decode(params.postId)[0];
    if (postId) {
      console.log('Getting comments...');
      axios.get(`${config.apiEndPoint}/articles/${postId}/comments`).then((response) => {
        console.log('Got comments...');
        console.log(response.data);
        this.setState({ comments: response.data });
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  adjustIframeHeight = (elId) => {
    window.addEventListener('message', (message) => {
      const $iframe = jQuery(elId);
      if (message.data.type === 'resize' && $iframe) {
        if (message.data.uuid === elId.replace('#', '')) {
          $iframe.height(message.data.height);
        }
      }
    });
  };

  // TODO Move this to a Saga or at least a central REST API handler
  saveComment = () => {
    const { match: { params }, auth } = this.props;
    const { commentText, selectedMessage, comments } = this.state;
    const postId = hashids.decode(params.postId)[0];
    console.log('Clicked send...');
    if (commentText && commentText.length > 0) {
      console.log('Saving comment...');
      axios.post(`${config.apiEndPoint}/articles/${postId}/comments`, {
        article_id: postId,
        // FIXME We don't want any HTML past this point - convert to plain text - use something better than this approach?
        comment: commentText.replace('<br>', ''),
        user_id: auth.user.id,
        parent_id: selectedMessage ? selectedMessage.id : null,
      }).then((response) => {
        const updatedComments = comments;
        updatedComments.push(response.data);
        this.setState({ comments: [...updatedComments], commentText: null });
      });
    } else {
      // TODO Highlight error
    }
  }

  scrollToComments = () => {
    document.getElementById('comment-container').scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  showComments = (message, scrollToComments) => {
    const { item } = this.props;
    if (isMobile) {
      this.props.history.push({ pathname: `/articles/${hashids.encode(item.id)}/comments`, state: { message } });
    } else {
      if (scrollToComments) {
        this.scrollToComments();
      }
      // FIXME Use the parent ID / selectedMessage to determine whether the user should be included in the text field and comment rows
      this.setState({
        selectedMessage: message,
        commentText: message && message.user ? `<strong>${message.user.full_name}</strong>&nbsp;${this.state.commentText || ''}` : this.state.commentText || '',
      });
      jQuery('#article-detail-comment-content').focus();
    }
  }

  // FIXME Automatic iframe height - set this globally for all iframes, or only iframes with certain class
  //  https://www.tutorialrepublic.com/faq/automatically-adjust-iframe-height-according-to-its-contents-using-javascript.php
  renderCigarDetails = () => {
    const { item, settings } = this.props;
    const { night_mode } = settings;
    if (item.cigar_id) {
      this.adjustIframeHeight('#cigar-detail-embed');
      return (
        <div>
          <h3>About this cigar</h3>
          <iframe
            id="cigar-detail-embed"
            src={night_mode ? `${config.embedEndPoint}/cigars/${item.cigar_id}/details?style=dark#cigar-detail-embed` : `${config.embedEndPoint}/cigars/${item.cigar_id}/details#cigar-detail-embed`}
            width="100%"
            frameBorder="0"
            scrolling="no"
            style={{ marginBottom: 10 }}
          />
        </div>
      );
    }
    return null;
  };

  renderCigarProducts = () => {
    const { item, settings } = this.props;
    const { night_mode } = settings;
    if (item.cigar_id) {
      this.adjustIframeHeight('#cigar-products-embed');
      return (
        <div>
          <h3>Where to buy</h3>
          <iframe
            id="cigar-products-embed"
            src={night_mode ? `${config.embedEndPoint}/products/cigars/${item.cigar_id}/buybutton?style=dark#cigar-products-embed` : `${config.embedEndPoint}/products/cigars/${item.cigar_id}/buybutton#cigar-products-embed`}
            width="100%"
            frameBorder="0"
            scrolling="no"
            style={{ marginBottom: 10 }}
          />
        </div>
      );
    }
    return null;
  };

  renderVenueDetails = () => {
    const { item, settings } = this.props;
    const { night_mode } = settings;
    if (item.venue_id) {
      this.adjustIframeHeight('#venue-detail-embed');
      return (
        <div>
          <h3>Venue Details</h3>
          <iframe
            id="venue-detail-embed"
            src={night_mode ? `${config.embedEndPoint}/venues/${item.venue_id}/details?style=dark` : `${config.embedEndPoint}/venues/${item.venue_id}/details`}
            width="100%"
            frameBorder="0"
            scrolling="no"
            style={{ marginBottom: 10 }}
          />
        </div>
      );
    }
    return null;
  };

  renderImageAttribution = () => <div className="content_body_text" dangerouslySetInnerHTML={{ __html: this.props.item.imageAttribution }} />;

  renderPodcastPlayer = () => {
    const { item, settings } = this.props;
    const { night_mode } = settings;
    if (item.podcast_player_url) {
      return (
        <div>
          <h3>Play the briefing</h3>
          {night_mode && (<iframe src={`${item.podcast_player_url}&style=modern`} width="100%" height="80" frameBorder="0" scrolling="no" />)}
          {!night_mode && (<iframe src={item.podcast_player_url} width="100%" height="200" frameBorder="0" scrolling="no" />)}
          { this.renderPodcastLinks() }
        </div>
      );
    }
    return null;
  };

  renderFooter = () => (
    <div className="row" style={{ marginTop: 20 }}>
      <div className="col-md-6" style={{ marginBottom: isMobile ? 16 : 0 }}>
        <p>
          <span>Thanks for reading!</span>
          <img className="alignnone wp-image-3936 size-full" src="https://cdn.boxpressd.io/placeholder/boxpressd-liked.png" alt="Boxpressd Like Icon" width="35" height="25" style={{ width: 35, marginLeft: 8, marginTop: -8 }} />
        </p>
        <br />
        <p>If you enjoyed this article, say Hello On:</p>
        <a href="https://instagram.com/cigarsnearme" target="_blank">Instagram</a>
        {' '}
        |
        <a href="https://facebook.com/cigarsnearme" target="_blank">Facebook</a>
        {' '}
        |
        <a href="https://twitter.com/cigarsnearme" target="_blank">X</a>
        {' '}
        |
        <a href="https://anchor.fm/cigars365" target="_blank">Anchor</a>
      </div>
      <div style={{ margin: 16 }}>
        <a href="https://bxpr.sd/cigars365-alexa-skills" target="_blank">
          <img src="https://cdn.cigarsnearme.com/assets/img/BottomofBlogArticleAlexaAd.jpg" />
        </a>
      </div>
      <div className="col-md-12">
        <span>&quot;Hey Google, listen to Cigars 365&quot; or &quot;Alexa, cigar reviews&quot;</span>
        <img src="https://cdn.boxpressd.io/placeholder/assistants.png" alt="Boxpressd Voice Assistants" style={{ maxWidth: '100%', maxHeight: 65, display: 'block' }} />
      </div>
    </div>
  );

  renderPodcastLinks = () => (
    <div className="styles__listeningPlatforms___3SAK-" style={{ marginTop: 8 }}>
      <h3>Where to listen</h3>
      <div className="css-3n7dts" style={{ display: 'flex' }}>
        <div className="styles__wrapper___1wrBP">
          <a
            href="https://itunes.apple.com/us/podcast/cigars-365/id1445502160"
            target="_blank"
            rel="noopener noreferrer"
            className="css-1z0xd9g"
          >
            <div className="styles__iconWrapper___9XLUZ">
              <img
                src="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/apple_podcasts.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/apple_podcasts.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/apple_podcasts@2x.png 2x"
                alt="Apple Podcasts Logo"
                width="28"
                height="28"
              />
              {/* <p className="styles__text___1SXNv">Apple Podcasts</p> */}
            </div>
          </a>
        </div>
        <div className="styles__wrapper___1wrBP">
          <a
            href="https://www.breaker.audio/cigars-365"
            target="_blank"
            rel="noopener noreferrer"
            className="css-1z0xd9g"
          >
            <div className="styles__iconWrapper___9XLUZ">
              <img
                src="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/breaker.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/breaker.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/breaker@2x.png 2x"
                alt="Breaker Logo"
                width="28"
                height="28"
              />
              {/* <p className="styles__text___1SXNv">Breaker</p> */}
            </div>
          </a>
        </div>
        <div className="styles__wrapper___1wrBP">
          <a
            href="https://castbox.fm/channel/id1548399"
            target="_blank"
            rel="noopener noreferrer"
            className="css-1z0xd9g"
          >
            <div className="styles__iconWrapper___9XLUZ">
              <img
                src="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/castbox.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/castbox.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/castbox@2x.png 2x"
                alt="Castbox Logo"
                width="28"
                height="28"
              />
              {/* <p className="styles__text___1SXNv">Castbox</p> */}
            </div>
          </a>
        </div>
        <div className="styles__wrapper___1wrBP">
          <a
            href="https://www.google.com/podcasts?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy83NTA1OGI0L3BvZGNhc3QvcnNz"
            target="_blank"
            rel="noopener noreferrer"
            className="css-1z0xd9g"
          >
            <div className="styles__iconWrapper___9XLUZ">
              <img
                src="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/google_podcasts.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/google_podcasts.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/google_podcasts@2x.png 2x"
                alt="Google Podcasts Logo"
                width="28"
                height="28"
              />
              {/* <p className="styles__text___1SXNv">Google Podcasts</p> */}
            </div>
          </a>
        </div>
        <div className="styles__wrapper___1wrBP">
          <a
            href="https://overcast.fm/itunes1445502160/cigars-365"
            target="_blank"
            rel="noopener noreferrer"
            className="css-1z0xd9g"
          >
            <div className="styles__iconWrapper___9XLUZ">
              <img
                src="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/overcast.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/overcast.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/overcast@2x.png 2x"
                alt="Overcast Logo"
                width="28"
                height="28"
              />
              {/* <p className="styles__text___1SXNv">Overcast</p> */}
            </div>
          </a>
        </div>
        <div className="styles__wrapper___1wrBP">
          <a
            href="https://pca.st/3F5D"
            target="_blank"
            rel="noopener noreferrer"
            className="css-1z0xd9g"
          >
            <div className="styles__iconWrapper___9XLUZ">
              <img
                src="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/pocket_casts.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/pocket_casts.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/pocket_casts@2x.png 2x"
                alt="Pocket Casts Logo"
                width="28"
                height="28"
              />
              {/* <p className="styles__text___1SXNv">Pocket Casts</p> */}
            </div>
          </a>
        </div>
        <div className="styles__wrapper___1wrBP">
          <a
            href="https://radiopublic.com/cigars-365-WzEB7E"
            target="_blank"
            rel="noopener noreferrer"
            className="css-1z0xd9g"
          >
            <div className="styles__iconWrapper___9XLUZ">
              <img
                src="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/radiopublic.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/radiopublic.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/radiopublic@2x.png 2x"
                alt="RadioPublic Logo"
                width="28"
                height="28"
              />
              {/* <p className="styles__text___1SXNv">RadioPublic</p> */}
            </div>
          </a>
        </div>
        <div className="styles__wrapper___1wrBP">
          <a
            href="https://open.spotify.com/show/3F25sGDIaPVhi1nstQ7bC0"
            target="_blank"
            rel="noopener noreferrer"
            className="css-1z0xd9g"
          >
            <div className="styles__iconWrapper___9XLUZ">
              <img
                src="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/spotify.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/spotify.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/spotify@2x.png 2x"
                alt="Spotify Logo"
                width="28"
                height="28"
              />
              {/* <p className="styles__text___1SXNv">Spotify</p> */}
            </div>
          </a>
        </div>
        <div className="styles__wrapper___1wrBP">
          <a
            href="https://www.stitcher.com/podcast/anchor-podcasts/cigars-365-2"
            target="_blank"
            rel="noopener noreferrer"
            className="css-1z0xd9g"
          >
            <div className="styles__iconWrapper___9XLUZ">
              <img
                src="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/stitcher_dark.png"
                srcSet="https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/stitcher_dark.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/podcast/logo-square/006/stitcher_dark@2x.png 2x"
                alt="Stitcher Logo"
                width="28"
                height="28"
              />
              {/* <p className="styles__text___1SXNv">Stitcher</p> */}
            </div>
          </a>
        </div>
        <div role="button" tabIndex="0" className="css-8bfpek">
          <div className="css-8bfpek">
            <div className="styles__iconWrapper___9XLUZ">
              <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" className="">
                <g fill="none" fillRule="evenodd">
                  <rect fill="#FE8A4C" width="28" height="28" rx="6"></rect>
                  <path
                    d="M6.822 18.5361504c.74088889 0 1.36666667.2645781 1.87755556.7932873.51866666.5139607.77777777 1.1398755.77777777 1.877074 0 .7371984-.25911111 1.3666886-.77777777 1.888247-.51088889.5139608-1.13666667.7707177-1.87755556.7707177-.73355556 0-1.35555556-.2567569-1.86666667-.7707177-.51088889-.5215584-.76644444-1.1508251-.76644444-1.888247 0-.737422.25555555-1.3633368.76644444-1.877074.51133334-.5289327 1.13311111-.7932873 1.86666667-.7932873zm-2.54422222-6.9831622c.17022222-.1937408.38488889-.3054714.644-.3351918v-.011173h1.08888889c2.97044444 0 5.51133333 1.0576418 7.62244443 3.1731489 2.1111111 2.1003117 3.1775556 4.6441939 3.2 7.6309762v1.0614406h-.0113333c-.0222222.2382097-.1184445.4431236-.2891111.6145183-.1702223.1713947-.3775556.2719523-.622.3018961v.011173h-1.8555556c-.2595555-.0073742-.4853333-.0969821-.678-.2681534-.1926667-.1861432-.3037778-.4058055-.3333333-.6592105h-.0113334v-1.0614407h.0113334c-.0222222-1.9291404-.7148889-3.5791778-2.0777778-4.9494419-1.38533333-1.3633367-3.03733333-2.0446699-4.95577778-2.0446699h-.04355555v.0111731H4.92177778v-.0111731c-.23688889-.0299438-.44444445-.126479-.622-.2904995-.17066667-.1713947-.26311111-.379884-.27777778-.6256913H4v-1.8661244c.01466667-.2607792.10711111-.4880393.27777778-.6815567zM4 6.89382242v-1.877074c.01466667-.26077921.10711111-.48803924.27777778-.68155663.17022222-.19374086.38488889-.30547145.644-.33519179h1.08888889C10.9515556 4 15.1813333 5.75774572 18.6995556 9.27368409 22.2182222 12.7967732 23.9848889 17.0425358 24 22.0109719v1.0614407h-.0113333c-.0295556.2382096-.1257778.4431235-.2891111.6145183-.1702223.1713947-.3775556.2719522-.622.301896V24h-1.8553334c-.2595555-.0073742-.4853333-.0969822-.678-.2681534-.1926666-.1861432-.3037778-.4058056-.3333333-.6592105h-.0113333v-1.0614407h.0113333c-.0146667-3.918392-1.4108889-7.2627121-4.1886667-10.0336309-2.7704444-2.78589066-6.10755553-4.17872426-10.01133331-4.17872426h-.04422222v.01117306H4.92177778v-.01117306c-.23688889-.02256958-.44444445-.11910482-.622-.29049955-.17066667-.1716182-.26311111-.37630865-.27777778-.61451827H4z"
                    fill="#FFF"
                    fillRule="nonzero"
                  >
                  </path>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  renderShareHandler = () => {
    if (isMobile) {
      return (
        <button onClick={this.shareArticle}>
          <div><Icon icon="share" size={22} alt="share" /></div>
        </button>
      );
    }
    return null;
  };

  renderMainContent() {
    const { loading, errorMessage, item, related, auth } = this.props;
    const { user } = auth;

    if (errorMessage) {
      return (
        <p>
          Error:
          {errorMessage}
        </p>
      );
    }
    if (loading) {
      return (
        <div className="page">
          <div className="content_body">
            <Skeleton height={200} width="100%" />
            <div style={{ textAlign: 'center' }}>
              <Skeleton width={300} height={30} style={{ margin: 'auto' }} />
            </div>
            <div><Skeleton width={100} height={20} /></div>
            <div><Skeleton width={100} height={20} /></div>
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </div>
        </div>
      );
    }
    if (!item) {
      return null;
    }

    // console.log(item);
    return (
      <div className="page">
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <div style={{ flex: 1, maxWidth: 728 }}>
            <div className="content_body">
              <div style={{ height: isMobile ? 200 : 300, backgroundImage: `url(${Resize.size(item.largeImage || item.image, { width: 728, height: 'auto', cropType: 'crop' })})`, backgroundPosition: 'center center', backgroundSize: 'cover', display: item.image ? 'block' : 'none', borderRadius: 5 }} />
              <h1 className="title_page" dangerouslySetInnerHTML={{ __html: item.title }} style={{ fontSize: 32, marginTop: 12 }} />
              {isMobile && (
                <div style={{ width: '100%', textAlign: 'center' }}>
                  {mainMobileLeaderboard()}
                </div>
              )}
              <div className="more_post" style={{ margin: '16px 0' }}>
                <span>
                  {'By '}
                  {item.author}
                </span>
                <span style={{ display: 'block', margin: '5px 0', color: '#69798F' }}>{this.formatDate(item.date)}</span>
                <ActionIconGroup
                  comments
                  containerStyle={{ float: 'right', marginTop: -65 }}
                  commentHandler={() => this.showComments(null, true)}
                  toggleSavedItem={this.toggleSavedItem}
                  itemSaved={this.state.itemSaved}
                  shareTo={this.shareArticle}
                />
              </div>
              <div className="content_body_text" dangerouslySetInnerHTML={{ __html: updateLinks(item.content) }} style={{ marginBottom: 20 }} />

              { this.state.showCigarProducts && this.renderCigarProducts() }
              { this.state.showCigarDetails && this.renderCigarDetails() }
              { this.state.showVenueDetails && this.renderVenueDetails() }
              { this.renderImageAttribution() }
              { this.renderPodcastPlayer() }
              { this.renderFooter() }
            </div>
            {isMobile && (
              <div style={{ width: '100%', textAlign: 'center', marginTop: 20, marginBottom: 20 }}>
                {mainMediumRectangle()}
              </div>
            )}
            {!isMobile && (
              <div style={{ width: '100%', marginTop: 20, marginBottom: 20 }}>
                {mainLeaderboard()}
              </div>
            )}
            <div id="comment-container" className="content_body" style={{ marginTop: 20 }}>
              <h3>Comments</h3>
              {this.state.comments.length > 0 && (
                <CommentList
                  compact
                  comments={this.state.comments}
                  onReply={(message) => this.showComments(message)}
                />
              )}
              {!user && (
                <div>
                  {'Please '}
                  <a href={`${config.authEndPoint}/login?path=${encodeURIComponent(window.location.href)}`} style={{ textDecoration: 'underline' }}>log in</a>
                  {' to add comments'}
                </div>
              )}
              {user && isMobile && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar src={user.image_url} style={{ height: 28, width: 28, marginRight: 10 }} />
                  <input
                    value={this.state.commentText}
                    onChange={(e) => this.setState({ commentText: e.target.value })}
                    className="form-control form-input"
                    onClick={() => this.props.history.push(`/articles/${hashids.encode(item.id)}/comments`)}
                    style={{ width: '100%', margin: '20px 0', height: 'auto' }}
                    placeholder="Write a comment..."
                  />
                </div>
              )}
              {user && !isMobile && (
                // TODO Include submit button?
                <div style={{ display: 'flex' }}>
                  <Avatar src={user.image_url} style={{ height: 28, width: 28, marginTop: 14, marginRight: 10 }} />
                  <ContentEditable
                    id="article-detail-comment-content"
                    className="contenteditable form-control form-control-clean form-input"
                    tagName="div"
                    html={this.state.commentText}
                    placeholder="Write a comment..." // TODO FB changes this text depending on whether it's a 'comment' on a post or a 'reply' to a comment
                    onChange={(e) => this.setState({ commentText: e.target.value })}
                    // onBlur={sanitize}
                    style={{ fontSize: 13, marginTop: 12 }}
                  />
                  <Button
                    color="primary"
                    size="small"
                    onClick={this.saveComment}
                    style={{ height: 38, marginTop: 10, marginLeft: 10 }}
                  >
                    {'Send'}
                  </Button>
                </div>
              )}
            </div>
            {isMobile && (
              <div style={{ width: '100%', textAlign: 'center', marginTop: 20, marginBottom: 20 }}>
                {secondaryMediumRectangle()}
              </div>
            )}
            {!isMobile && (
              <div style={{ width: '100%', marginTop: 20, marginBottom: 20 }}>
                {secondaryLeaderboard()}
              </div>
            )}
            <div className="related" style={{ marginTop: 20 }}>
              <h3>Related Articles</h3>
              <div className="row" style={{ marginLeft: 0, marginRight: 0 }}>
                {isMobile && related.slice(1).map((r) => (
                  <RelatedCard key={r.id} item={r} />
                ))}
                {!isMobile && (
                  <Carousel infinite slidesToShow={4} slidesToScroll={4} style={{ width: '100%' }}>
                    { related.slice(1).map((r) => (
                      <RelatedCard key={r.id} item={r} />
                    ))}
                  </Carousel>
                )}
              </div>
            </div>
          </div>
          {!isMobile && (
            <div style={{ width: 310, marginLeft: 20 }}>
              {mainTower()}
              {mainMediumRectangle()}
              {secondaryMediumRectangle()}
              {tertiaryMediumRectangle()}
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { item } = this.props;
    const title = item && item.title;
    const description = item && item.excerpt.replace(/<\/?[^>]+(>|$)/g, '');
    const image = item && (item.largeImage || item.image);

    return (
      <PageWrap>
        <PageMeta
          type="Article"
          title={title}
          description={description}
          imageUrl={image}
          canonical={window.location.href}
        >
          {this.renderMainContent()}
        </PageMeta>
      </PageWrap>
    );
  }
}

WpPostDetail.propTypes = {
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
  item: PropTypes.object,
  related: PropTypes.object,
  params: PropTypes.object,
  loadItem: PropTypes.func,
  loadRelatedItem: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    auth: state.get('auth').toJS(),
    settings: state.get('settings'),
  };
}

export default withRouter(connect(mapStateToProps)(WpPostDetail));
